import { Injectable } from '@angular/core';
import { CourseResource } from '../../models/api/course-resource.model';

@Injectable({
    providedIn: 'root'
})
export class CourseResourceService {

    constructor() { }

    public findResource(resources: CourseResource[], resourceName: string, editionId: number) {

        var editionResource = resources.find(r => r.editionId === editionId && r.resourceId === resourceName);
        var resource = editionResource ? editionResource : resources.find(r => r.editionId === 0 && r.resourceId === resourceName);
        
        return resource ? resource.value : null;

    }

}
